import { type ReactNode, useEffect } from 'react'

import { type OlarkHelperState, useOlarkStore } from './useOlarkStore.ts'

type Props = Partial<OlarkHelperState>

export const useOlarkHelper = (state: Props) => {
  const { update } = useOlarkStore(s => s.actions)
  useEffect(() => () => {
    update({ loadId: undefined })
  })
  useEffect(() => {
    update(state)
  }, [state, update])
}
export const useOlarkLastPjChatId = (chatId: string): void => {
  const { update } = useOlarkStore(s => s.actions)

  useEffect(() => {
    update({ lastPjChatId: chatId })
  }, [chatId, update])
}

export const OlarkHelper = (state: Props): ReactNode => {
  useOlarkHelper(state)
  return null
}
